import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo Api 回傳值
 */
export interface ProofDocUploadViewDataResp extends GeneralResp {
    imageMaxSize: number;

    ntdAccount: IAccount | null;
    foreignAccount: IAccount | null;
    withdrawalForeignAccounts: Array<IAccount> | [] | null;
    fileNoPassportOrCreditCard: string | null;

    branch:string;
    financialProofAgree: boolean | null;
    financeFileList: Array<ProofDocObj> | [] | null;
}

declare interface ProofDocObj {
    index: number;
    isUploading: boolean | null | undefined;
    fileNo: string | null | undefined; // 上傳後的id
}

export enum AccountType {
    deposite = 'deposite', // 台幣出金 / 外幣出金
    withdrawal = 'withdrawal' // 台幣外幣入金
}
/**
 * @todo 台幣外幣帳戶空物件樣板
 */
declare interface IAccount {
    type: AccountType;
    coin: {
        twd: boolean;
        usd: boolean;
        cny: boolean;
        jpy: boolean;
    };
    bank: string;
    branch: string;
    number: string;
    fileNo: string | null | undefined;
    base64Src: string | null | undefined;
    base64Src_errorMsg: string | null | undefined;
    index: number;
    isUploading: boolean | null | undefined;
    coin_errorMsg: string | null;
    bank_errorMsg: string | null;
    branch_errorMsg: string | null;
    number_errorMsg: string | null;
}

/**
 * @todo 出入金帳號約定/證明文件上傳 ViewData
 */
const ProofDocUploadViewData = (): Promise<ProofDocUploadViewDataResp> => {
    const url = RouteUrlList.API_ProofDocUploadViewData.path;
    const config = {
        params: { showOverlay: ApiClient.paramTypeEnum.true, getServiceAlert: ApiClient.paramTypeEnum.true }
    };
    return ApiClient.post(url, {}, config).then((res: AxiosResponse<ProofDocUploadViewDataResp>) => {
        return res.data;
    });
};

export default ProofDocUploadViewData;
